function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React from 'react';
import { Translate } from "../../I18N";
import { useForm } from 'react-hook-form';
import Modal from "../../Layout/Modal";
import { sanitizeThesaurusLabel } from "../../../shared/sanitizationUtils";













const createSelectValues = (values) => {
  const selectOptions = [{ value: 'root', label: '<root>' }];
  if (!values) return selectOptions;
  values.
  filter((value) => value.values).
  forEach((value) => selectOptions.push({ value: value.id, label: value.label }));
  return selectOptions;
};

const AddThesauriValueModal = ({
  isOpen,
  values,
  onAccept,
  onCancel
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    reset
  } = useForm({ defaultValues: { group: 'root' } });

  const onSubmitted = (submittedValues) => {
    // Sanitize the value before accepting
    const sanitizedValues = _objectSpread(_objectSpread({},
    submittedValues), {}, {
      value: sanitizeThesaurusLabel(submittedValues.value) });

    onAccept(sanitizedValues);
  };

  const renderGroupSelect = (selectValues) => /*#__PURE__*/
  React.createElement(React.Fragment, null, /*#__PURE__*/
  _jsx("label", { className: "form-label", htmlFor: "group" }, void 0, /*#__PURE__*/
  _jsx(Translate, {}, void 0, "Group")
  ), /*#__PURE__*/
  React.createElement("select", _extends({},
  register('group'), {
    className: "form-control thesauri-group",
    defaultValue: "root",
    id: "group" }),

  selectValues.map((option) => /*#__PURE__*/
  _jsx("option", { value: option.value }, option.value,
  option.label
  )
  )
  )
  );


  const validateDuplicates = (newValue) => {
    let innerValues = values;
    if (newValue.group !== 'root') {var _values$find;
      innerValues = ((_values$find = values.find((value) => value.id === newValue.group)) === null || _values$find === void 0 ? void 0 : _values$find.values) || [];
    }
    const index = innerValues.findIndex((value) => value.label === newValue.value);
    return index === -1;
  };

  const selectValues = createSelectValues(values);

  return (/*#__PURE__*/
    _jsx(Modal, { isOpen: isOpen, type: "info", className: "add-thesauriValue-modal" }, void 0, /*#__PURE__*/
    _jsx("form", {
      onSubmit: async (e) => {
        e.preventDefault();
        e.stopPropagation();
        await handleSubmit(onSubmitted)(e);
      },
      className: "file-form" }, void 0, /*#__PURE__*/

    _jsx(Modal.Header, {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Add thesaurus value")
    ), /*#__PURE__*/
    _jsx(Modal.Body, {}, void 0,
    errors.value && /*#__PURE__*/
    _jsx("p", { className: "error", role: "alert" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Duplicate values not allowed.")
    ),

    selectValues.length > 1 && renderGroupSelect(selectValues), /*#__PURE__*/
    _jsx("label", { htmlFor: "newThesauriValue" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Value")
    ), /*#__PURE__*/
    React.createElement("input", _extends({},
    register('value', {
      required: true,
      validate: () => validateDuplicates(getValues())
    }), {
      className: "form-control",
      placeholder: "value",
      id: "newThesauriValue" })
    )
    ), /*#__PURE__*/

    _jsx(Modal.Footer, {}, void 0, /*#__PURE__*/
    _jsx("button", {
      type: "button",
      className: "btn cancel-button",
      onClick: () => {
        reset({ group: 'root', value: '' });
        onCancel();
      } }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Cancel")
    ), /*#__PURE__*/
    _jsx("button", { type: "submit", className: "btn btn-success confirm-button" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Save")
    )
    )
    )
    ));

};

export default AddThesauriValueModal;